import React from 'react';
import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ErrorPageI {
  title: string;
  message: string;
  redirect: string;
  redirectLabel: string;
}

export default function ErrorPage(props: ErrorPageI) {
  const navigate = useNavigate();
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            sx={{
              height: '100vh',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box sx={{ textAlign: 'center', mt: '-200px' }}>
              <Typography variant='h3'>{props.title}</Typography>
              <Typography variant='body1'>{props.message}</Typography>
              <Button
                variant='outlined'
                onClick={() => navigate(props.redirect)}
              >
                {props.redirectLabel}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
